<template lang="pug">
  #key-container
    span.map-key-item(
      v-for='category in categories'
      @click='toggleCategory(category.value)'
      :class='{active: !activeCategories[category.value]}')
      img.tooltip(
        :src="'/static/img/map/' + category.value + '.png'"
        :title='category.label')
</template>





<script>
  import {mapState} from 'vuex'
  import categories from '@/mixins/categories'
  import qs from 'qs'

  export default {
    name: 'map-key',

    computed: mapState([
      'activeCategories',
      'isLoadingResources'
    ]),

    data () {
      return {
        /**
         * To add new categories, simply add a new {key, tooltip}.
         * - Add a corresponding `/static/img/map/${key}.png` marker image.
         * - For markers, @see https://mapicons.mapsmarker.com/
         * @type {Array}
         */
        categories
      }
    },

    methods: {
      toggleCategory (category) {
        let activeCategories = []
        let query = qs.parse(location.search, {ignoreQueryPrefix: true}) || {}

        this.$store.commit('toggleCategories', [category])
        this.$store.commit('filterResources')

        // Extract only the active categories
        for (let cat in this.activeCategories) {
          if (!this.activeCategories[cat]) {
            activeCategories.push(cat)
          }
        }

        query.cat = activeCategories.join(',')
        this.$router.replace({query})
      }
    }
  }
</script>





<style lang="sass">
  #key-container
    position: relative
    text-align: center
    cursor: grab
    padding: 10px
    box-shadow: 0 0 3px rgba(0,0,0,0.35)
    z-index: 1
    user-select: none

    &:active
      cursor: grabbing

  .map-key-item
    display: inline-block
    margin-right: 5px
    margin-left: 5px
    vertical-align: middle
    cursor: pointer
    opacity: 0.35
    transition: opacity 0.35s ease

    &.active
      opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/map/Key.vue